<!--继承el-select-->
<script>
import { Select } from 'element-ui';

export default {
  name: 'mySelect',
  extends: Select
};
</script>

<style scoped>

</style>
